import { Link } from "gatsby"
import React from "react"

const CarrierLogos = ({ data }) => {

  return (
    <>
      <div className="logos-slide">
        {data.carriers.edges.filter(({ node: carrier }) => {
          const image = carrier.frontmatter.carrier_logo.childImageSharp
          console.log(carrier)
          return !(!image || image.fluid.src.includes("cna"))
        }).map(({ node: carrier }, i) => (
          <Link to={"/versandsoftware" + carrier.fields.slug} key={i}>
            <img src={carrier.frontmatter.carrier_logo.childImageSharp?.fluid.src}
                 alt={carrier.frontmatter.carrierf_name} />
          </Link>
        ))}
      </div>
    </>
  )
}
export default CarrierLogos
